import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ACCESS_REQUEST_REPOSITORY } from '../domain/repositories/access-request.repository';
import { AccessRequestRemoteDatasource } from './datasources/remote/access-request.remote-datasource';
import { AccessRequestRepositoryImpl } from './repositories/access-request.repository.impl';

export function provideAccessRequestData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AccessRequestRemoteDatasource,
    { provide: ACCESS_REQUEST_REPOSITORY, useClass: AccessRequestRepositoryImpl },
  ]);
}
